import React from 'react';
import './AllProjects.css'
import  f1 from '../../image/f1.png'
import  f2 from '../../image/f2.png'
import  f3 from '../../image/f3.png'
import  f4 from '../../image/f4.png'
import  f5 from '../../image/f5.png'
import  f6 from '../../image/f6.png'
const Front = () => {
  return (
    <div className="container">
      <div className="row mt-5">

      <div className='col-md-6'> 
      <div className="card-box">
      <div className='image-wrap'>
        <img src= {f1} alt="example card" />
        <figcaption className="price">
        <a target='_blank' href='https://imdb-clone-ac4.pages.dev/'><button class="custom-btn btn-12"><span>Click</span><span>Demo</span></button></a>
        </figcaption>
      </div>
      <div className="content-box">
        <h2 className="title"> Cinverse-IMDb Clone</h2>
        <div className="text-box">
          <p>
          Welcome to our IMDb Clone, a feature-rich movie database application that brings the cinematic world to your fingertips. This project is designed to provide users with a seamless and immersive experience as they explore, discover, and engage with a vast collection of movies. Let's dive into the key features and the technology stack that powers this impressive movie-centric platform.
        <hr/>
         <strong>  Key Features:</strong>
          
          <h4>🔍 Search Functionality:</h4>
          
          Utilize our powerful search feature to find information on any movie. Uncover details such as release date, cast, director, rating, overview, and view stunning poster images. The search functionality makes it easy for users to access comprehensive movie data effortlessly.
          🍿 Watch Trailers:
          
          Elevate your movie exploration with our one-click access to trailers. Immerse yourself in the cinematic experience by seamlessly watching trailers right from the application. Get a preview of the movie before deciding to watch it.
          📈 Trending & Top-Rated Lists:
          
          Stay ahead of the cinematic trends with our curated lists. Discover the latest trending movies and explore top-rated films based on user reviews. Our lists provide a quick and enjoyable way to navigate through the most popular and critically acclaimed movies.
          📱 Fully Responsive:
          
          Experience the application on any device with our fully responsive design. Whether you're using a desktop, tablet, or smartphone, the IMDb Clone adapts effortlessly to provide a consistent and user-friendly interface.
          Technology Stack:
          <br/>
          <strong>🌐 React 18:</strong>
          
          Leveraging the latest version of React, our application ensures a modern and dynamic user interface. React 18 introduces exciting features and improvements, enhancing the overall performance and user experience.
          <br/>
          <strong>🧰 Redux Toolkit:</strong>
          
          Manage the state of the application efficiently with Redux Toolkit. This powerful state management library enables seamless communication between components, ensuring a smooth and responsive user interface.
          <br/>
         <strong> 🎨 Bootstrap 5:</strong>
          
          The application's visual appeal is powered by Bootstrap 5, providing a sleek and polished design. Bootstrap's responsive grid system ensures a consistent layout across different screen sizes, contributing to an aesthetically pleasing user experience.
          <br/>
          <strong>Data Source (API Integration):</strong>
          
          We have integrated the TMDb (The Movie Database) API to offer users access to an extensive collection of movie data. This integration enables real-time updates, ensuring that our users have the latest information at their fingertips.
          Immerse yourself in the world of cinema with our IMDb Clone, where user-friendly design meets a wealth of movie-related information. Explore, discover, and enjoy the magic of movies with our feature-rich platform.
          </p>
          
        </div>
      </div>
    </div>
    
      </div>


      <div className='col-md-6'> 
      <div className="card-box">
      <div className='image-wrap'>
        <img src= {f2} alt="example card" />
        <figcaption className="price">
        <a target='_blank' href='https://fitness-ca6.pages.dev/'><button class="custom-btn btn-12"><span>Click</span><span>Demo</span></button></a>
        </figcaption>
      </div>
      <div className="content-box">
        <h2 className="title">FitHub - Your Ultimate Fitness Companion</h2>
        <div className="text-box">
          <p>
          Welcome to our Fitness Web App, a dynamic platform designed to empower users on their fitness journey. This React-based application seamlessly integrates cutting-edge technologies to provide a user-friendly experience, enabling individuals to explore, learn, and engage in a wide range of exercises. Let's delve into the key features and the technology stack that make this fitness web app a valuable resource for fitness enthusiasts. <br/>
         <strong>  Key Features:</strong>
          
          <h4>🔍 Search Functionality:</h4>
          
          With our intuitive search functionality, users can effortlessly discover a variety of exercises tailored to their fitness goals. Simply enter the desired exercise name, and our platform will provide comprehensive results, allowing users to explore a diverse range of workout options.
         📹 Tutorial Videos:

         Enhance your workout routine with our extensive collection of tutorial videos. Each exercise comes with a dedicated video tutorial, providing step-by-step guidance on proper form and technique. Users can watch and learn directly from fitness experts, ensuring a safe and effective workout experience.
        📊 Detailed Exercise Information:

        Gain in-depth insights into each exercise, including muscle groups targeted, equipment required, and difficulty level. Our platform provides a comprehensive overview of each exercise to help users make informed decisions about incorporating them into their fitness routines.<br/>
         
         <strong>Technology Stack:</strong>
          <br/>
          <strong>🌐 React 18:</strong>
          
          Leveraging the latest version of React, our application ensures a modern and dynamic user interface. React 18 introduces exciting features and improvements, enhancing the overall performance and user experience.
          <br/>
          <strong>🧰 Redux Toolkit:</strong>
          
          Manage the state of the application efficiently with Redux Toolkit. This powerful state management library enables seamless communication between components, ensuring a smooth and responsive user interface.
          <br/>
         <strong> 🎨 Bootstrap 5:</strong>
          
          The application's visual appeal is powered by Bootstrap 5, providing a sleek and polished design. Bootstrap's responsive grid system ensures a consistent layout across different screen sizes, contributing to an aesthetically pleasing user experience.
          <br/>
          <strong>Data Source (API Integration):</strong>
          
          To ensure up-to-date and dynamic content, we've integrated the Rapid API ExerciseDB database. This API connection allows our platform to fetch real-time exercise data, keeping our exercise library rich and diverse. Users can trust that they have access to the latest information on various exercises.
          </p>
          
        </div>
      </div>
    </div>
    
      </div>

      <div className='col-md-6'> 
      <div className="card-box">
      <div className='image-wrap'>
        <img src= {f3} alt="example card" />
        <figcaption className="price">
        <a href='https://realreact.pages.dev/' target='_blank'><button class="custom-btn btn-12"><span>Click</span><span>Demo</span></button></a>
        </figcaption>
      </div>
      <div className="content-box">
        <h2 className="title"> Real Estate Web App UI in ReactJS</h2>
        <div className="text-box">
          <p>
          The Real Estate Web Application is designed to provide users with an intuitive and efficient platform to search, explore, and inquire about available properties. The application aims to streamline the property discovery process, offering users a comprehensive view of listed properties, detailed property information, and an easy-to-use inquiry system. <br/>
         <strong>  Key Features:</strong>
          
          <h4>User-Friendly Property Listings</h4>
          
          The application presents a visually appealing and user-friendly interface, showcasing a diverse range of available properties for sale or rent.<br/>
          Users can easily navigate and filter property listings based on location, price range, and property type, ensuring a tailored and efficient search experience.
          <h4>Advanced Search Functionality:</h4>

          The advanced search functionality allows users to fine-tune their property search based on specific criteria, ensuring that they find properties that match their preferences and requirements.
          <h4>Responsive Design with Framer Motion:</h4>
          
          The application is developed using React-JS for a responsive and dynamic user experience.
          Framer Motion is employed to introduce subtle animations, enhancing the overall aesthetic appeal and usability of the platform.
         <br/>
         <strong>Technology Stack:</strong>
          <br/>
          <strong>🌐 React 18:</strong>
          
          Leveraging the latest version of React, our application ensures a modern and dynamic user interface. React 18 introduces exciting features and improvements, enhancing the overall performance and user experience.
          <br/>
          
         <strong> 🎨 Animation:</strong>
          
         Framer Motion for introducing subtle animations and enhancing the visual app
          <br/>
          
          </p>
          
        </div>
      </div>
    </div>
    
      </div>

      <div className='col-md-6'> 
      <div className="card-box">
      <div className='image-wrap'>
        <img src= {f4} alt="example card" />
        <figcaption className="price">
        <a href='https://resturent.pages.dev/' target='_blank'><button class="custom-btn btn-12"><span>Click</span><span>Demo</span></button></a>
        </figcaption>
      </div>
      <div className="content-box">
        <h2 className="title">Fine-Dine Resuturent UI in ReactJS</h2>
        <div className="text-box">
          <p>
          Welcome to Gastronome Elegance, an exquisite static website meticulously crafted in ReactJS, offering a virtual journey into the world of fine dining. This project aims to present a seamless and visually appealing platform where visitors can explore the restaurant's menu, discover contact details, and delve into the unique ambiance and offerings of this culinary haven. <br/>
         <strong>  Key Features:</strong>
          
          <h4>🔍 🍽️ Menu Showcase:</h4>
          
          Immerse yourself in a culinary journey through our meticulously curated menu. Gastronome Elegance showcases a symphony of flavors, each dish beautifully presented with tantalizing descriptions. From appetizers to desserts, our menu section offers a feast for the eyes and a preview of the exquisite dining experience that awaits.
          <br/>
          <h4>📞 Contact Details:</h4>
          Connect with us effortlessly through our contact details section. Whether you have inquiries, reservation requests, or simply want to share your dining experiences, our contact information is readily available. Gastronome Elegance values communication and is committed to providing excellent customer service. <br/>
          <h4>🌐 Immersive Design:</h4>
          Our website boasts a visually stunning and immersive design, reflecting the sophistication and elegance synonymous with fine dining. The user interface is carefully crafted to enhance the overall dining experience, mirroring the ambiance of our restaurant in the digital realm..<br/>

          <h4>🎨 Aesthetic Appeal:</h4>
          Gastronome Elegance prioritizes aesthetics to create a visually enticing experience for visitors. The color palette, imagery, and layout are thoughtfully chosen to evoke a sense of luxury and refinement, setting the stage for an exceptional dining adventure<br/>
         
         <strong>Technology Stack:</strong>
          <br/>
          <strong>🌐 React 18:</strong>
          
          Leveraging the latest version of React, our application ensures a modern and dynamic user interface. React 18 introduces exciting features and improvements, enhancing the overall performance and user experience.
          <br/>
          <h4>Embark on a Digital Culinary Journey:</h4>
          Gastronome Elegance invites you to embark on a digital exploration of fine dining excellence. Whether you're planning a visit, seeking menu inspiration, or simply indulging in the visual delights of gastronomy, our website promises an immersive experience. Join us at Gastronome Elegance - where the art of culinary sophistication meets the digital realm, and every click is a step closer to a memorable dining experience.
          </p>
          
        </div>
      </div>
    </div>
    
      </div>

      <div className='col-md-6'> 
      <div className="card-box">
      <div className='image-wrap'>
        <img src= {f5} alt="example card" />
        <figcaption className="price">
        <a href='https://cherylkidd.pages.dev/' target='_blank'><button class="custom-btn btn-12"><span>Click</span><span>Demo</span></button></a>
        </figcaption>
      </div>
      <div className="content-box">
        <h2 className="title"> Multi-pages website HTML Design </h2>
        <div className="text-box">
          <p>
           Impressive & Responsive Front-End Project <br/>
          <br/>
         
         <strong>Technology Stack: </strong>
           HTML , CSS , Bootstrap 
          </p>
          
        </div>
      </div>
    </div>
    
      </div>



 



      <div className='col-md-6'> 
      <div className="card-box">
      <div className='image-wrap'>
        <img src= {f6} alt="example card" />
        <figcaption className="price">
        <a href='https://baredesign.pages.dev/' target='_blank'><button class="custom-btn btn-12"><span>Click</span><span>Demo</span></button></a>
        </figcaption>
      </div>
      <div className="content-box">
        <h2 className="title"> Multi-pages E-commerce website HTML Design </h2>
        <div className="text-box">
          <p>
           Impressive & Responsive Front-End Project  <br/>
           Multipage E-commerece web-site , including all login , signup page , product detail page ,cart page, checkout product page with a beautiful UI 
          <br/>
         
         <strong>Technology Stack: </strong>
           HTML , CSS , Bootstrap , JS
          </p>
          
        </div>
      </div>
    </div>
    
      </div>
      
      </div>
    </div>
  );
};

export default Front;
